import _isNil from 'lodash/isNil';
import _head from 'lodash/head';
import _last from 'lodash/last';
import { EMPTY_ARRAY } from '@tekion/tekion-base/app.constants';
var checkMinSafeIntegerValue = function checkMinSafeIntegerValue(values) {
  return _head(values) === Number.MIN_SAFE_INTEGER;
};
var checkMaxSafeIntegerValue = function checkMaxSafeIntegerValue(values) {
  return _last(values) === Number.MAX_SAFE_INTEGER;
};
export var getMinAmount = function getMinAmount(values) {
  var isMinIntegerValue = checkMinSafeIntegerValue(values);
  return isMinIntegerValue ? undefined : _head(values);
};
export var getMaxAmount = function getMaxAmount(values) {
  var isMaxIntegerValue = checkMaxSafeIntegerValue(values);
  return isMaxIntegerValue ? undefined : _last(values);
};
export var getOnChangeUpdatedValues = function getOnChangeUpdatedValues(minValue, maxValue) {
  var updatedMinAmount = _isNil(minValue) ? Number.MIN_SAFE_INTEGER : minValue;
  var updatedMaxAmount = _isNil(maxValue) ? Number.MAX_SAFE_INTEGER : maxValue;
  if (updatedMinAmount === Number.MIN_SAFE_INTEGER && updatedMaxAmount === Number.MAX_SAFE_INTEGER) {
    return EMPTY_ARRAY;
  }
  return [updatedMinAmount, updatedMaxAmount];
};